{
    "Detailstitle": "Detalhes do segmento de chamada",
    "Recordingtitle": "Gravação de segmento de chamada",
    "Details": "Detalhes",
    "Recording": "Gravação",
    "Value": "Valor",
    "Collapseall": "Recolher todos",
    "FieldStatistic": "Campo \/ Estatística",
    "Calldatetimevalues": "Valores de data\/hora da chamada",
    "Deviceinformation": "Informação de dispositivo",
    "Calltypestatus": "Tipo e estado de chamada",
    "Callmovement": "Informações do Cenário de Movimento de Chamada",
    "Calldurationvalues": "Valores de duração da chamada",
    "Telephoneinformation": "Informações do número de telefone",
    "Acdinformation": "Informações do Agente ACD",
    "Associatedtelephonyenvironment": "Ambiente de Telefonia Associado",
    "Diagnosticvalues": "Valores de diagnóstico",
    "Previous": "Anterior",
    "Next": "Próximo",
    "Playrecording": "Reproduzir Gravação",
    "Errorplayrecording": "Falha ao obter a gravação",
    "Norecording": "Sem Gravação(ões)",
    "Retrievingrecordings": "A obter gravações...",
    "Backtodetails": "Voltar para detalhes",
    "Segmentid": "Copiar ID da Cadeia do Segmento",
    "Copied": "Copiado!",
    "Help": "Ajuda",
    "Close": "Fechar",
    "RecordingTimeoutError": "O número máximo de tentativas para obter as gravações desta chamada foi excedido.",
    "EditableHint": "Clique na descrição para editar este campo.",
    "EditPlaceholder": "Clique aqui para adicionar descrição",
    "ReloadDataP1": "Uma entrada foi atualizada recentemente,",
    "ReloadDataP2": "Clique aqui",
    "ReloadDataP3": "para recarregar os dados.",
    "DescMaxLengthValidation": "Há um comprimento máximo de caracteres de 100.",
    "ConfirmChange": "confirme",
    "CancelChange": "Cancelar",
    "NAME": "CallDetails",
    "AccountCodeHint": "Clique no código da conta para editar este campo.",
    "AccountCodePlaceholder": "Clique aqui para adicionar o código da conta",
    "DescriptionHint": "Clique na descrição para editar este campo.",
    "DescriptionPlaceholder": "Clique aqui para adicionar a descrição",
    "NoAccountCodes": "Não existem códigos de conta disponíveis",
    "First": "Primeiro",
    "Last": "Durar",
    "CallJourneyTitle": "Chamada de jornada",
    "CallRecordingTitle": "Gravação de chamadas",
    "CallSegmentTitle": "Segmento {} de {}",
    "TabTextTimeline": "Linha do tempo",
    "TabTextSegments": "Segmentos",
    "TabTextRecording": "Gravação",
    "StatisticDeviceCalled": "Nome\/Número Chamado",
    "StatisticDeviceCalling": "Nome\/Número de chamador",
    "StatisticTotalCallTime": "Tempo total de chamada",
    "StatisticStatus": "Estado",
    "Answered": "Respondido",
    "NotAnswered": "Não respondido",
    "StatisticTotalCallTimeInProgress": "Chamada em curso"
}